module.exports = __webpack_public_path__ + "img/Plan3.5625d4b5.jpg";